module.exports = __webpack_public_path__ + "img/c32.77f18301.png";